import { ChangeEvent, ClickEvent, Component, DataDisplayEvent, DataSourceRemoteDataChangeEvent, TableRowDisplayEvent, TableRowExpansionEvent, TableSelectionEvent } from "@mcleod/components";
import { LogManager, ModelRow } from "@mcleod/core";
import { FilterPanel } from "@mcleod/dispatch";
import { AutogenLayoutHoldBrokerageMovementTable } from "./autogen/AutogenLayoutHoldBrokerageMovementTable";
import { BrokerageMovementTableListeners, BrokerageMovementTableConfigure, BrokerageMovementTable } from "./BrokeragePlanningUtil";
import { BrokerageMovementTableType } from "./BrokerageMovementTableType";
import { BrokeragePlanning } from "./BrokeragePlanning";
import { BrokeragePlanningToolPanel } from "./BrokeragePlanningToolPanel";
import {PlanningUtil} from "@mcleod/dispatch/src/planning/PlanningUtil";

const log = LogManager.getLogger("lme.powerbroker.HoldBrokerageMovementTable");

export class HoldBrokerageMovementTable extends AutogenLayoutHoldBrokerageMovementTable implements BrokerageMovementTable {
    public type: BrokerageMovementTableType;
    public brokeragePlanning: BrokeragePlanning;
    public layoutBrokeragePlanningToolPanel: BrokeragePlanningToolPanel;
    public availFilterPanel: FilterPanel;


    async onLoad(): Promise<void> {
        this.layoutBrokeragePlanningToolPanel.table = this.tableMovements;
        BrokerageMovementTableConfigure.brokerageMovementTableOnLoad(this.tableMovements, this.layoutBrokeragePlanningToolPanel);
    }

    configureTableForType(type: BrokerageMovementTableType) {
        this.type = type;
        BrokerageMovementTableConfigure.configureBrokerageTableForType(this.tableMovements, type, this.availFilterPanel, this.panelSecondaryFilters);
    }

    public get filter() {
        return this.type.filter;
    }

    tableMovementsOnSelect(event: TableSelectionEvent) {
        this.layoutBrokeragePlanningToolPanel.tableMovementsOnSelect(event);
    }

    sourceBrokerageMovementsOnRemoteDataChange(event: DataSourceRemoteDataChangeEvent) {
        this.layoutBrokeragePlanningToolPanel.onRemoteDataChange(event);
    }

    tableMovementsOnRowDisplay(event: TableRowDisplayEvent) {
        BrokerageMovementTableListeners.brokerageMovementTableonRowDisplayBPListener(event.getTableRow(), this.tableMovements, this.layoutBrokeragePlanningToolPanel, this.type)
    }

    setupComponentsOnRowDisplay(comp: Component, modelRow: ModelRow) {
        BrokerageMovementTableListeners.setupComponentsOnRowDisplayBPListener(comp, modelRow);
    }

    textboxPlanningCommentOnClick(event: ClickEvent) {
        PlanningUtil.textboxPlanningCommentOnClickListener(event);
    }

    textboxPlanningCommentOnDblClick(event: ClickEvent) {
        PlanningUtil.textboxPlanningCommentOnDblClickListener(event);
    }

    openStatusSlideout(event: ClickEvent) {
        BrokerageMovementTableListeners.openStatusSlideoutBPListener(event)
    }

    openICSlideout(event: ClickEvent) {
        BrokerageMovementTableListeners.openICSlideoutBPListener(event)
    }

    buttonEditCommentOnClick(event: ClickEvent) {
        PlanningUtil.buttonEditCommentOnClickListener(event);
    }

    async buttonSaveCommentOnClick(event: ClickEvent) {
        PlanningUtil.buttonSaveCommentOnClickListener(event);
    }

    buttonCancelCommentOnClick(event: ClickEvent) {
        PlanningUtil.buttonCancelCommentOnClickListener(event);
    }

    panelBrkStatusOnClick(event: ClickEvent) {
        BrokerageMovementTableListeners.panelBrkStatusOnClickBPListener(event, this.layoutBrokeragePlanningToolPanel, this.tableMovements);
    }

    imageAppointmentOnClick(event: ClickEvent) {
        BrokerageMovementTableListeners.imageAppointmentOnClickBPListener(event);
    }

    orderNumberOnClick(event: ClickEvent) {
        BrokerageMovementTableListeners.orderNumberOnClickBPListener(event)
    }

    customerIdOnClick(event: ClickEvent) {
        BrokerageMovementTableListeners.customerIdOnClickBPListener(event);
    }

    manifestIdOnClick(event: ClickEvent) {
        BrokerageMovementTableListeners.manifestIdOnClickBPListener(event)
    }

    onRowExpand(event: TableRowExpansionEvent) {
        BrokerageMovementTableListeners.onRowExpandBPListener(event, this.tableMovements, this.brokeragePlanning, this.type);
    }

    /** This is an event handler for the onDataDisplay event of badgeBrTrackStatus.  */
    badgeBrTrackStatusOnDataDisplay(event: DataDisplayEvent) {
        BrokerageMovementTableListeners.badgeBrTrackStatusOnDataDisplayBPListener(event);
    }

    badgeBrTrackStatusOnDblClick(event: ClickEvent) {
        BrokerageMovementTableListeners.badgeBrTrackStatusOnDblClickBPListener(event);
    }

    imageLoadboardOnClick(event: ClickEvent) {
        BrokerageMovementTableListeners.imageLoadboardOnClickBPListener(event);
    }

    textboxPlanningCommentOnChange(event: ChangeEvent) {
        PlanningUtil.textboxPlanningCommentOnChangeListener(event);
    }

    sendSmsBtnOnClick(event: ClickEvent) {
        BrokerageMovementTableListeners.sendSmsBtnOnClickBPListener(event);
    }

    cellStopsOnClick(event: ClickEvent) {
        BrokerageMovementTableListeners.cellStopsOnClickBPListener(event);
    }

}
